module.exports = __webpack_public_path__ + "static/media/starBg.0d5793b0.png";